import { ProjectFileSection, ProjectFileUsage } from 'src/utils/enums'

export type MatrixGroupDef = {
  key: string
  title: string
  section: ProjectFileSection
  usages: ProjectFileUsage[]
}

export const DP_MATRIX_GROUP: MatrixGroupDef = {
  key: 'DP_MATRIX',
  title: 'Matrice DP',
  section: ProjectFileSection.DESIGN,
  usages: [
    ProjectFileUsage.DP_MATRIX,
    ProjectFileUsage.DP1,
    ProjectFileUsage.DP2,
    ProjectFileUsage.DP2_1,
    ProjectFileUsage.DP3,
    ProjectFileUsage.DP4_1,
    ProjectFileUsage.DP4_2,
    ProjectFileUsage.DP4_3,
    ProjectFileUsage.DP4_4,
    ProjectFileUsage.DP6,
    ProjectFileUsage.DP78,
    ProjectFileUsage.DP11,
  ],
}

export const PC_MATRIX_GROUP: MatrixGroupDef = {
  key: 'PC_MATRIX',
  title: 'Matrice PC',
  section: ProjectFileSection.DESIGN,
  usages: [
    ProjectFileUsage.PC_MATRIX,
    ProjectFileUsage.PCMI1,
    ProjectFileUsage.PCMI2,
    ProjectFileUsage.PCMI2_1,
    ProjectFileUsage.PCMI3,
    ProjectFileUsage.PCMI4,
    ProjectFileUsage.PCMI5_1,
    ProjectFileUsage.PCMI5_2,
    ProjectFileUsage.PCMI5_3,
    ProjectFileUsage.PCMI5_4,
    ProjectFileUsage.PCMI6,
    ProjectFileUsage.PCMI78,
  ],
}

export const CERFA_DP_GROUP: MatrixGroupDef = {
  key: 'CERFA_DP_GROUP',
  title: 'Cerfa DP',
  section: ProjectFileSection.ADMINISTRATIVE,
  usages: [ProjectFileUsage.CERFA_DP, ProjectFileUsage.CERFA_13703_11],
}

export const CERFA_PC_GROUP: MatrixGroupDef = {
  key: 'CERFA_PC_GROUP',
  title: 'Cerfa PC',
  section: ProjectFileSection.ADMINISTRATIVE,
  usages: [ProjectFileUsage.CERFA_PC, ProjectFileUsage.CERFA_13406_12],
}

export const CERFA_PCM_GROUP: MatrixGroupDef = {
  key: 'CERFA_PCM_GROUP',
  title: 'Cerfa PCM',
  section: ProjectFileSection.ADMINISTRATIVE,
  usages: [ProjectFileUsage.CERFA_PCM, ProjectFileUsage.CERFA_13411_11],
}

export const FACADE_GROUPS: readonly MatrixGroupDef[] = [
  {
    key: 'FACADE_1_CURRENT',
    title: 'Image facade 1 actuel',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.CURRENT_FACADE_1, ProjectFileUsage.CURRENT_FACADE_5],
  },
  {
    key: 'FACADE_2_CURRENT',
    title: 'Image facade 2 actuel',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.CURRENT_FACADE_2, ProjectFileUsage.CURRENT_FACADE_6],
  },
  {
    key: 'FACADE_3_CURRENT',
    title: 'Image facade 3 actuel',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.CURRENT_FACADE_3, ProjectFileUsage.CURRENT_FACADE_7],
  },
  {
    key: 'FACADE_4_CURRENT',
    title: 'Image facade 4 actuel',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.CURRENT_FACADE_4, ProjectFileUsage.CURRENT_FACADE_8],
  },
  {
    key: 'FACADE_1_FUTUR',
    title: 'Image facade 1 futur',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.FUTUR_FACADE_1, ProjectFileUsage.FUTUR_FACADE_5],
  },
  {
    key: 'FACADE_2_FUTUR',
    title: 'Image facade 2 futur',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.FUTUR_FACADE_2, ProjectFileUsage.FUTUR_FACADE_6],
  },
  {
    key: 'FACADE_3_FUTUR',
    title: 'Image facade 3 futur',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.FUTUR_FACADE_3, ProjectFileUsage.FUTUR_FACADE_7],
  },
  {
    key: 'FACADE_4_FUTUR',
    title: 'Image facade 4 futur',
    section: ProjectFileSection.DESIGN,
    usages: [ProjectFileUsage.FUTUR_FACADE_4, ProjectFileUsage.FUTUR_FACADE_8],
  },
]

export const MATRIX_GROUPS: readonly MatrixGroupDef[] = [
  DP_MATRIX_GROUP,
  PC_MATRIX_GROUP,
  CERFA_DP_GROUP,
  CERFA_PC_GROUP,
  CERFA_PCM_GROUP,
  ...FACADE_GROUPS,
]

const MATRIX_USAGE_INDEX: ReadonlyMap<ProjectFileUsage, MatrixGroupDef> =
  new Map(
    MATRIX_GROUPS.flatMap((g) =>
      g.usages.map(
        (u) => [u, g] as [ProjectFileUsage, MatrixGroupDef]
      )
    )
  )

export const matrixGroupForUsage = (
  usage: ProjectFileUsage
): MatrixGroupDef | undefined => MATRIX_USAGE_INDEX.get(usage)
